<template>
  <div class="asc-chips-filter-manager">
    <template v-for="(option, index) in defaultFilterOptions">
      <template v-if="option.optionType === 'timeline'">
        <div
          :key="`${index}-timeline`"
          class="asc-chips-filter-manager--timeline"
        >
          <asc-timeline-filter
            :option-filter="option.optionFilter"
            @filterChanged="handleTimelineFilterChanged"
          ></asc-timeline-filter>
        </div>
      </template>
      <template v-if="option.optionType === 'autocomplete'">
        <div
          :key="`${index}-autocomplete`"
          class="asc-chips-filter-manager--autocomplete"
        >
          <asc-chips-filter
            :option-filters="option.optionFilters"
            @filterChanged="handleAutocompleteFilterChanged"
          ></asc-chips-filter>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import AscChipsFilter from '@/components/molecules/AscChipsFilter'
import AscTimelineFilter from '@/components/molecules/AscTimelineFilter'

export default {
  name: 'AscChipsFilterManager',

  components: {
    AscChipsFilter,
    AscTimelineFilter,
  },

  props: {
    defaultFilterOptions: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      currentFilter: null,
      filterOptions: this.defaultFilterOptions,
      itemsLoaded: false,
    }
  },

  watch: {
    defaultFilterOptions: {
      handler: function (newValue) {
        if (newValue) {
          const autocompleteItems = newValue.filter(
            item => item.optionType === 'autocomplete',
          )
          const [autocompleteItem] = autocompleteItems
          const optionFilters = autocompleteItem?.optionFilters || []
          if (optionFilters) {
            const validItems =
              optionFilters.filter(item => item.items.length > 0).length ===
              optionFilters.length
            if (!this.itemsLoaded && validItems) {
              this.filterOptions = newValue
              this.itemsLoaded = true
            }
          }
        }
      },
      immediate: true,
    },
  },

  mounted() {
    this.init()
  },

  methods: {
    init() {
      if (!this.currentFilter) {
        this.currentFilter = {}
        this.filterOptions.forEach(filter => {
          if (filter.optionType === 'timeline') {
            this.currentFilter.timelineIndex = 2
            this.currentFilter.timelineText = '1m'
          }

          if (filter.optionType === 'autocomplete') {
            this.currentFilter.radioIndex = '0'
            filter.optionFilters.forEach(optionFilter => {
              this.currentFilter[optionFilter.propName] =
                optionFilter.checkedIds
            })
          }
        })
      }
    },

    handleTimelineFilterChanged(filter) {
      this.mergeFilter(filter)
      this.$emit('filterChanged', this.currentFilter)
    },

    handleAutocompleteFilterChanged(filter) {
      this.mergeFilter(filter)
      this.$emit('filterChanged', this.currentFilter)
    },

    mergeFilter(filter) {
      const updatedFilter = {
        ...this.currentFilter,
        ...filter,
      }
      this.currentFilter = updatedFilter
    },
  },
}
</script>

<style lang="scss">
.asc-chips-filter-manager {
  display: flex;
  position: relative;

  &--timeline {
    width: 140px;
  }

  &--autocomplete {
    width: calc(100% - 156px);
    flex-grow: 1;
  }
}
</style>
